import { connect } from "react-redux";
import ResultInfo from "components/atoms/ResultInfo";
import { getQueryFilterName } from "utils/filter";

const mapStateToProps = (state, ownProps) => {
  const searchTerm =
    state.filters &&
    state.filters[getQueryFilterName()] &&
    state.filters[getQueryFilterName()].values &&
    state.filters[getQueryFilterName()].values[0];
  const count = (state.result && state.result.totalCount) || 0;

  return { ...ownProps.resultInfo, count, searchTerm, isSizeSmall: true };
};

export default connect(mapStateToProps)(ResultInfo);
